import React from "react";
import { useParams } from "react-router-dom";

// 🔥 IMPORTANTE: ajusta rutas si cambian
import EditorialPreview from "../admin/produccion/editorial/EditorialPreview";

export default function PrintView() {

  const { type } = useParams();

  // 🔥 DATA DESDE LOCALSTORAGE (FUENTE ÚNICA)
  const storedData = localStorage.getItem("print_data");
  const data = storedData ? JSON.parse(storedData) : null;

  // 🔴 CONTROL BÁSICO (importante)
  if (!data) {
    return (
      <div style={{ padding: 40 }}>
        No se encontró contenido para imprimir
      </div>
    );
  }

  return (
    <div
      className="print-root"
      style={{
        background: "#fff",
        minHeight: "100vh",
        padding: "40px 0"
     }}
>
      {/* 🔥 CONTENIDO */}
      <EditorialPreview data={data} isPrint={true} />

      {/* 🔥 BOTÓN REAL DE PRINT */}
      <div style={{ textAlign: "center", marginTop: 20 }}>
        <button
          onClick={() => window.print()}
          style={{
            padding: "10px 16px",
            borderRadius: 8,
            border: "1px solid #ccc",
            background: "#fff",
            cursor: "pointer",
            fontWeight: 600
          }}
        >
          Imprimir / Guardar PDF
        </button>
      </div>
    </div>
  );
}